document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.community--carousel').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var grid = document.getElementById('CommunityGrid-' + sectionId);
    var prevBtn = root.querySelector('.community__arrow--prev');
    var nextBtn = root.querySelector('.community__arrow--next');
    if (!grid) return;

    function scrollByOne(direction) {
      var item = grid.querySelector('.community__item');
      var amount = item ? item.getBoundingClientRect().width + 16 : 300;
      grid.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });
  });
});